module.exports = __webpack_public_path__ + "static/media/open.16ca9413.svg";